import { formatISO, getISOWeek, isSameISOWeek, parseISO } from "date-fns";
import _ from "underscore";

function uniqueId() {
    return `${Date.now()}-${Math.floor(Math.random() * 100)}`;
}

export const FormReducer = function (state, action) {
    const payload = action.payload;

    switch (action.type) {
        case "ORDER_SUCCESSFUL":
            return { ...state, success: action.payload };

        case "SHOW_ERROR":
            return { ...state, error: action.payload };

        case "CLEAR_ERROR":
            return { ...state, error: undefined };

        case "TOGGLE_ROLE":
            return { ...state, roleId: payload };

        case "ADD_PARTICIPANT":
            return {
                ...state,
                participants: [
                    ...state.participants,
                    {
                        ...action.participantDefaults(),
                        id: uniqueId(),
                    },
                ],
            };

        case "REMOVE_PARTICIPANT":
            return {
                ...state,
                participants:
                    state.participants.length > 1
                        ? state.participants.filter(
                            (_, index) => index == !payload
                        )
                        : state.participants,
            };
        case "UPDATE_GENERAL_INFORMATION":
            return {
                ...state,
                general: {
                    ...state.general,
                    [payload.field]: payload.value,
                },
            };
        case "UPDATE_GENERAL_FIELD":
            return {
                ...state,
                general: {
                    ...state.general,
                    fields: {
                        ...state.general.fields,
                        [payload.field]: payload.value,
                    },
                },
            };

        case "TOGGLE_DATE":
            const { participantIndex, offer, date } = payload
            let offers = state.participants[participantIndex].offers.slice().map(e => ({
                ...e,
                date: parseISO(e.date)
            }))

            let element = offers.filter(o => o.date.getTime() == date.getTime() && o.id == offer.id)[0]

            if (element) {
                offers = offers.filter(i => i != element)
            } else {
                const week = getISOWeek(date)
                element = {
                    date,
                    isWeek: !offer.daily,
                    week,
                    bookableDays: offer.bookableDays,
                    id: offer.id
                }
                offers = offers.filter(o => {
                    if (o.isWeek && o.week == week) return false;
                    if (!o.isWeek && o.date.getTime() == date.getTime()) return false;
                    if (!offer.daily && o.week == week) return false;
                    return true
                })
                offers.push(element)
            }

            offers = offers.map(o => ({ ...o, date: formatISO(o.date) }))

            console.log({ offers })

            return {
                ...state, participants: state.participants.map((participant, index) =>
                    payload.participantIndex == index
                        ? {
                            ...participant,
                            offers,
                        }
                        : participant
                )
            }


        case "UPDATE_PARTICIPANT_INFORMATION":
            return {
                ...state,
                participants: state.participants.map((participant, index) =>
                    payload.participantIndex == index
                        ? {
                            ...participant,
                            [payload.field]: payload.value,
                        }
                        : participant
                ),
            };

        case "UPDATE_PARTICIPANT_FIELD":
            return {
                ...state,
                participants: state.participants.map((participant, index) =>
                    payload.index == index
                        ? {
                            ...participant,
                            fields: {
                                ...participant.fields,
                                [payload.field.id]: payload.value,
                            },
                        }
                        : participant
                ),
            };

        case "ADD_TO_WAITINGLIST":
            return {
                ...state,
                participants: state.participants.map((participant, index) => {
                    return payload.participantIndex == index
                        ? {
                            ...participant,
                            waitingList: _.uniq([
                                ...(participant.waitingList || []),
                                payload.offer.id,
                            ]),
                        }
                        : participant;
                }),
            };

        case "ADD_OFFER":
            return {
                ...state,
                participants: state.participants.map((participant, index) => {
                    return payload.participantIndex == index
                        ? {
                            ...participant,
                            offers: _.uniq([
                                ...participant.offers,
                                payload.offer.id,
                            ]),
                            waitingList: (
                                participant.waitingList || []
                            ).filter(
                                (offerId) => offerId != payload.offer.id
                            ),
                        }
                        : participant;
                }),
            };

        case "DELETE_OFFER":
            return {
                ...state,
                participants: state.participants.map((participant, index) => {
                    return payload.participantIndex == index
                        ? {
                            ...participant,
                            offers: (participant.offers || []).filter(
                                (offerId) => offerId != payload.offer.id
                            ),
                            waitingList: (
                                participant.waitingList || []
                            ).filter(
                                (offerId) => offerId != payload.offer.id
                            ),
                        }
                        : participant;
                }),
            };

        case "TOGGLE_OFFER":
            const availableSlots = Math.max(
                0,
                payload.offer.limit - payload.offer.reservations
            );
            const waitingListSlots = Math.max(
                0,
                payload.offer.limitWaiting - payload.offer.reservationsWaiting
            );

            const isWaitingList = availableSlots == 0 && waitingListSlots > 0;
            return {
                ...state,
                participants: state.participants.map((participant, index) => {
                    const participantContainsOffer =
                        participant.offers.indexOf(payload.offer.id) >= 0;
                    const participantsContainsWaitingList =
                        waitingListSlots > 0;

                    return payload.participantIndex == index
                        ? {
                            ...participant,
                            offers: participantContainsOffer
                                ? participant.offers.filter(
                                    (offerId) => offerId != payload.offer.id
                                )
                                : [...participant.offers, payload.offer.id],

                            waitingList: participantsContainsWaitingList
                                ? participant.waitingList?.filter(
                                    (offerId) => offerId != payload.offer.id
                                )
                                : isWaitingList
                                    ? [
                                        ...participant.waitingList,
                                        payload.offer.id,
                                    ]
                                    : participant.offers,
                        }
                        : participant;
                }),
            };

        case "TOGGLE_RESOLVE_OFFER":
            const selectedOffers =
                state.resolve.selected[payload.participantIndex];
            var index = selectedOffers.indexOf(payload.offerId);
            if (index !== -1) {
                selectedOffers.splice(index, 1);
            } else {
                selectedOffers.push(payload.offerId);
            }

            return {
                ...state,
            };

        case "RESOLVE_CONFLICT":
            const resolve = {
                ...payload,
                selected: state.participants.map((p) => p.offers.slice()),
            };

            return {
                ...state,
                resolve,
            };

        case "CLEAR_CONFLICT":
            return {
                ...state,
                resolve: null,
            };
    }

    console.error("Unknown action", action);

    return state;
};
